import { useState, useEffect } from 'react';
import { adminAPI } from '@/lib/api';
import { toast } from 'sonner';
import { CheckCircle, Download, Search, Clock } from 'lucide-react';

export default function AdminBaixasConcluidas() {
  const [data, setData] = useState({ items: [], total: 0, page: 1, pages: 1 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [q, setQ] = useState('');

  const fetch_ = async () => {
    setLoading(true);
    try {
      const res = await adminAPI.baixasConcluidas({ page, limit: 25, q });
      setData(res.data);
    } catch { toast.error('Erro ao carregar'); }
    finally { setLoading(false); }
  };
  useEffect(() => { fetch_(); }, [page, q]);

  const handleExport = async () => {
    try {
      const res = await adminAPI.exportConcluidas();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([res.data]));
      a.download = 'baixas_concluidas.xlsx';
      document.body.appendChild(a); a.click(); a.remove();
      toast.success('Exportado!');
    } catch { toast.error('Erro ao exportar'); }
  };

  return (
    <div className="space-y-5" data-testid="admin-baixas-concluidas">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-2xl font-semibold">Baixas Concluidas</h1>
          <p className="text-sm text-white/50">{data.total} cliente(s) com processo finalizado</p>
        </div>
        <button onClick={handleExport} className="btn-primary flex items-center gap-2 text-sm">
          <Download size={16} /> Exportar XLSX
        </button>
      </div>

      <div className="relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
        <input value={q} onChange={e => { setQ(e.target.value); setPage(1); }}
          placeholder="Buscar nome, email..."
          className="w-full bg-black/20 border border-white/10 text-white text-sm placeholder:text-white/30 rounded-xl pl-10 pr-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[rgba(99,203,182,0.3)]" />
      </div>

      <div className="glass-card !p-0 overflow-hidden">
        {loading ? (
          <div className="flex justify-center py-10"><div className="rn-spinner" style={{width:24,height:24}} /></div>
        ) : data.items.length === 0 ? (
          <div className="text-center py-12">
            <CheckCircle size={36} className="mx-auto text-white/15 mb-2" />
            <p className="text-sm text-white/35">Nenhum processo finalizado ainda.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full min-w-[900px] text-sm">
              <thead>
                <tr className="border-b border-white/10 bg-white/[0.02]">
                  <th className="text-left text-[10px] text-white/40 font-medium py-2.5 px-3">NOME</th>
                  <th className="text-left text-[10px] text-white/40 font-medium py-2.5 px-3">CPF</th>
                  <th className="text-left text-[10px] text-white/40 font-medium py-2.5 px-3">PROTOCOLO</th>
                  <th className="text-left text-[10px] text-white/40 font-medium py-2.5 px-3">EMPRESAS</th>
                  <th className="text-left text-[10px] text-white/40 font-medium py-2.5 px-3">ULTIMA BAIXA</th>
                  <th className="text-left text-[10px] text-white/40 font-medium py-2.5 px-3">TEMPO</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map(row => (
                  <tr key={row.clientId} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                    <td className="py-2.5 px-3">
                      <p className="text-xs font-medium text-white/90">{row.nome}</p>
                      <p className="text-[9px] text-white/30">{row.email}</p>
                    </td>
                    <td className="py-2.5 px-3"><span className="text-xs font-mono text-white/60">{row.cpf}</span></td>
                    <td className="py-2.5 px-3">
                      <p className="text-xs text-white/70">{row.numeroProtocolo || '—'}</p>
                      {row.dataProtocolo && <p className="text-[9px] text-white/30">{new Date(row.dataProtocolo).toLocaleDateString('pt-BR')}</p>}
                    </td>
                    <td className="py-2.5 px-3">
                      <div className="flex flex-wrap gap-1">
                        {row.empresas?.map(e => (
                          <span key={e} className="badge-success text-[9px]">{e}</span>
                        ))}
                      </div>
                    </td>
                    <td className="py-2.5 px-3 text-xs text-white/50">
                      {row.dataUltimaBaixa ? new Date(row.dataUltimaBaixa).toLocaleDateString('pt-BR') : '—'}
                    </td>
                    <td className="py-2.5 px-3">
                      <span className="text-xs text-white/50 flex items-center gap-1">
                        <Clock size={12} /> {row.tempoProcesso || '—'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {data.pages > 1 && (
          <div className="flex items-center justify-between px-4 py-3 border-t border-white/10">
            <span className="text-xs text-white/35">Pag {page}/{data.pages}</span>
            <div className="flex gap-2">
              <button onClick={() => setPage(p => Math.max(1, p-1))} disabled={page === 1} className="btn-ghost text-xs px-3 py-1 disabled:opacity-30">Ant</button>
              <button onClick={() => setPage(p => Math.min(data.pages, p+1))} disabled={page === data.pages} className="btn-ghost text-xs px-3 py-1 disabled:opacity-30">Prox</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
